/**
 * The unified-access migration switch (PMO-62), read from the runtime config
 * the container writes to `/__env.js` (`NEXT_PUBLIC_UNIFIED_ACCESS_ENABLED`).
 *
 * Fail-closed: only the exact string `true` turns it on. It must be switched
 * together with the api's `UNIFIED_ACCESS_ENABLED`, which serves the
 * login-method discovery the email-first login calls.
 *
 * Read on every call rather than captured at import, so the value is whatever
 * the runtime config holds when the screen renders.
 */
export const isUnifiedAccessEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_UNIFIED_ACCESS_ENABLED === "true";
